/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Meta_Twitterdescription1Inputs */

const ja_home_meta_twitterdescription1 = /** @type {(inputs: Home_Meta_Twitterdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAINは東京を拠点とするゲームマーケティング・eスポーツ制作会社です。ゲームパブリッシャー、デベロッパー、ゲーミングブランドの日本・アジア市場での成長はもちろん、欧米市場への展開も支援しています。マーケティング戦略、クリエイティブ制作、インフルエンサーマーケティング、eスポーツイベント・配信、デジタルプラットフォーム、ECソリューションまで一貫して提供。Riot Games、Ubisoft、Konami、Sony INZONE、Razerをはじめ、多くのゲーム業界を代表する企業から信頼をいただいています。`)
};

const en_home_meta_twitterdescription1 = /** @type {(inputs: Home_Meta_Twitterdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAIN is a Tokyo-based game marketing agency helping publishers, developers, and gaming brands grow in Japan and Asia. We deliver end-to-end game marketing, esports production, influencer campaigns, creative services, digital platforms, and e-commerce solutions. Trusted by Riot Games, Ubisoft, Konami, Sony INZONE, Razer, and other leading gaming companies.`)
};

/**
* | output |
* | --- |
* | "PLAYBRAIN is a Tokyo-based game marketing agency helping publishers, developers, and gaming brands grow in Japan and Asia. We deliver end-to-end game marketi..." |
*
* @param {Home_Meta_Twitterdescription1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const home_meta_twitterdescription1 = /** @type {((inputs?: Home_Meta_Twitterdescription1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Meta_Twitterdescription1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_home_meta_twitterdescription1(inputs)
	return en_home_meta_twitterdescription1(inputs)
});
export { home_meta_twitterdescription1 as "home_meta_twitterDescription" }